module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-ordering-work.758ac466.webp";